import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import {
  userManagementUrl,
  accountsmanagement,
} from "../../../../config";
import {
  allUsers,
  allDocumentTypes, // assuming this fetches document types
} from "../../../../data/Queries/HRmanagement/leavemanagement";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";

const base_url = accountsmanagement.uri;

const DocumentApproversForm = (props) => {
  const [users, setUsers] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- INITIAL VALUES ---------------- */
  const initialValues = {
    documentTypeId: props.data?.documentTypeId || "",
    approverUserId: props.data?.approverUserId || "",
    isFinalApprover: props.data?.isFinalApprover || false,
  };

  /* ---------------- FETCH DROPDOWN DATA ---------------- */
  useEffect(() => {
    async function fetchData() {
      try {
        const usersData = await graphqlQuery(allUsers, userManagementUrl.uri);
        const documentTypesData = await graphqlQuery(
          allDocumentTypes,
          base_url
        );

        setUsers(usersData || []);
        setDocumentTypes(documentTypesData || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  /* ---------------- DROPDOWN OPTIONS ---------------- */
  const userOptions = users.map((user) => ({
    value: user.id,          // SENT
    label: user.username,    // DISPLAYED
  }));

  const documentTypeOptions = documentTypes.map((doc) => ({
    value: doc.id,               // SENT
    label: doc.documentTypeName, // DISPLAYED
  }));

  /* ---------------- FORM FIELDS ---------------- */
  const fields = [
    {
      name: "documentTypeId",
      label: "Document Type",
      type: "select",
      options: documentTypeOptions,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "approverUserId",
      label: "Approver",
      type: "select",
      options: userOptions,
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "isFinalApprover",
      label: "Final Approver",
      type: "checkbox",
      gridColumn: "span 2",
    },
  ];

  /* ---------------- SUBMIT HANDLER ---------------- */
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        documentTypeId: values.documentTypeId,
        approverUserId: values.approverUserId,
        isFinalApprover: values.isFinalApprover ? 1 : 0,
        isActive: 1,
        createdBy: props.currentUserId, // 🔴 ensure this is passed from parent
      };

      const response = await generateAndExecuteMutation(
        "createDocumentApprovers",
        mutationData,
        "newDocumentApprover",
        base_url
      );

      if (Object.values(response)[0]) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Document approver added successfully.",
        });
        props.onClose();
        props.onAction();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to save document approver.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={[
        {
          stepNumber: 1,
          stepLabel: "Document Approvers",
          stepDescription: "Configure document approval flow",
          fields: fields.map((f) => f.name),
        },
      ]}
      onSubmit={handleSubmit}
      title="Document Approvers Management"
      subtitle="Assign approvers per document type"
    />
  );
};

export default DocumentApproversForm;
